import { Navigate } from "react-router-dom";
import { hasPermission } from "./permissions";
import useIdleLogout from "../../useIdleLogout";

export default function ProtectedRoute({ module, children }) {
  useIdleLogout();

  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (module && !hasPermission(module)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}